import { topics } from '@/mocks/home';

export default function Topics() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          话题热议
        </h2>
        <div className="flex flex-wrap justify-center gap-3 max-w-[900px] mx-auto">
          {topics.map((topic, i) => (
            <div
              key={i}
              className="group flex items-center gap-2 px-4 py-2.5 bg-background-100 hover:bg-primary-50/50 rounded-full cursor-pointer transition-colors duration-200"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                # {topic.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}